import type { optionType } from "utils";

export const magicAIAspectRatioOptions: optionType[] = [
  { value: "16x9", label: "16x9" },
  { value: "1x1", label: "1x1" },
  { value: "9x16", label: "9x16" },
  { value: "4x3", label: "4x3" },
  { value: "3x4", label: "3x4" },
];

export const magicAIGenderOptions: optionType[] = [
  { value: "man", label: "man" },
  { value: "woman", label: "woman" },
  { value: "boy", label: "boy" },
  { value: "girl", label: "girl" },
];